import React from "react";
import { Grid2 } from "@mui/material";
import { ReactComponent as BlueprintSite } from "../../GlobalAssets/svg/Blueprint12.svg";
import { ReactComponent as DeleteIcon } from "../../GlobalAssets/svg/Delete.svg";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import styles from "./ImageUploader.module.scss";
import IconButton from "../IconButton/IconButton";

const ImageUploader = ({
  imagePreview,
  defaultImage,
  onDelete,
  onUploadClick,
  onFileChange,
  fileInputRef,
  maxSizeText = "Maximum Size: 220 X 120 less than 1MB",
  loading = false,
}) => {
  return (
    <Grid2 className={styles.uploadContainer}>
      <Grid2 className={styles.uploadLabel}>
        <label htmlFor="file-upload">
          <Grid2 className={styles.imageWrapper}>
            {imagePreview ? (
              <img
                src={imagePreview}
                className={styles.imagePreview}
                alt="Uploaded preview"
              />
            ) : (
              <BlueprintSite />
            )}
          </Grid2>
        </label>

        {imagePreview ? (
          <Grid2 className={styles.IconButton}>
            <IconButton
              icon={AddPhotoAlternateIcon}
              tooltipText="Upload"
              onClick={onUploadClick}
            />
            <IconButton
              icon={DeleteIcon}
              tooltipText="Delete"
              onClick={onDelete}
              loading={loading}
            />
          </Grid2>
        ) : (
          <Grid2 className={styles.imageMaximum}>
            <Grid2 className={styles.ChooseImage} onClick={onUploadClick}>
              <span className={styles.ChooseImageColor}>Choose image</span> to
              upload
            </Grid2>
            <Grid2 className={styles.MaximumSize}>{maxSizeText}</Grid2>
          </Grid2>
        )}
      </Grid2>
      <input
        id="file-upload"
        className={styles.fileInput}
        type="file"
        onChange={onFileChange}
        accept="image/png, image/gif, image/jpeg"
        ref={fileInputRef}
      />
    </Grid2>
  );
};

export default ImageUploader;
